export const config = {
  cognito: {
    region: 'sa-east-1',
    userPoolId: 'sa-east-1_oUKT8vD64',
    userPoolWebClientId: '1r17cfl6uskln6lkda3054vbt2'
  },
  api: {
    baseUrl: 'https://qr.blantcosmeticos.com.br'
  },
  publicUrl: 'https://qr.blantcosmeticos.com.br'
};